import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { MeetingState } from "./types";
import {
  getAudioTranscriptionAction,
  getMeetingMessagesAction,
  meetingChatWithResponsesAction,
  postAudioFileAction,
  startMeetingChatAction,
} from "./actions";

export function postAudioFileActionReducerBuilder(
  builder: ActionReducerMapBuilder<MeetingState>
) {
  builder.addCase(postAudioFileAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.meetingValue = action.payload;
  });
}

export function getAudioTranscriptionActionReducerBuilder(
  builder: ActionReducerMapBuilder<MeetingState>
) {
  builder.addCase(getAudioTranscriptionAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.meetingValue = action.payload;
  });
}

export function startMeetingChatReducerBuilder(
  builder: ActionReducerMapBuilder<MeetingState>
) {
  builder.addCase(startMeetingChatAction.pending, (state) => {
    state.isMessageLoading = true;
  });
  builder.addCase(startMeetingChatAction.fulfilled, (state, action) => {
    state.isMessageLoading = false;
    if (!action.payload) return;
    state.messages = [
      ...state.messages,
      { role: "assistant", content: action.payload },
    ];
  });
  builder.addCase(startMeetingChatAction.rejected, (state) => {
    state.isMessageLoading = false;
  });
}

export function meetingChatWithResponsesReducerBuilder(
  builder: ActionReducerMapBuilder<MeetingState>
) {
  builder.addCase(meetingChatWithResponsesAction.pending, (state) => {
    state.isMessageLoading = true;
  });
  builder.addCase(meetingChatWithResponsesAction.fulfilled, (state, action) => {
    state.isMessageLoading = false;
    if (!action.payload) return;
    state.messages = [
      ...state.messages,
      {
        role: "assistant",
        content: action.payload.content?.at(-1)?.text as string,
      },
    ];
  });
  builder.addCase(meetingChatWithResponsesAction.rejected, (state) => {
    state.isMessageLoading = false;
  });
}

export function getMeetingMessagesReducerBuilder(
  builder: ActionReducerMapBuilder<MeetingState>
) {
  builder.addCase(getMeetingMessagesAction.pending, (state) => {
    state.isMessageLoading = true;
  });
  builder.addCase(getMeetingMessagesAction.fulfilled, (state, action) => {
    state.isMessageLoading = false;
    if (!action.payload) return;
    state.messages = action.payload;
  });
  builder.addCase(getMeetingMessagesAction.rejected, (state) => {
    state.isMessageLoading = false;
  });
}
